import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useGetInsuranceTypeByIdQuery,
  useUpdateInsuranceTypeMutation,
} from "AppQuries/master/InsuranceType/insurancetype";
import { insuranceValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import InsuranceForm from "Components/Form/InsuranceForm";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const EditInsuranceType = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: insuranceData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetInsuranceTypeByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  const {
    mutate: updateInsuranceType,
    isPending,
    isError,
    error,
  } = useUpdateInsuranceTypeMutation();
  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(insuranceValidationSchema),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  console.log(errors);

  const onSubmit = (payload) => {
    console.log(payload);
    updateInsuranceType(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success(`Insurance Updated Successfully.`);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.insurancetype}`);
          }, 1000);
        } else {
          toast.warning("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const [settingData, setSettingData] = useState(true);

  useEffect(() => {
    if (Array.isArray(insuranceData) && insuranceData.length > 0) {
      Object.keys(insuranceData[0]).forEach((key) => {
        // if (
        //   insuranceData[0][key] === "attachment" &&
        //   !insuranceData[0][key] !== null
        // ) {

        // } else {
          setValue(key, insuranceData[0][key]);
        // }
      });
      setSettingData(false);
    }
  }, [insuranceData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending || settingData) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Insurance</h4>
                    <h6>Edit your Insurance </h6>
                  </div>
                </div>
                
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}/${all_routes.insurancetype}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update Insurance</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Insurance</h4>
                    </div>
                    <div className="card-body">
                      <InsuranceForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditInsuranceType;
